<template>
  <CFooter>
    <div class="ms-auto">
      <span class="me-1 app-version" target="_blank">
        UMWA TOOL V{{ appVersion }}
      </span>
    </div>
  </CFooter>
</template>

<script>
import p from '../../package'
export default {
  name: 'AppFooter',
  data() {
    return {
      appVersion: p.version,
    }
  },
}
</script>
